module.exports = __webpack_public_path__ + "img/vanessa-bange.bb68ad2d.jpg";